import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/raven-logo.jpg" 
                alt="Raven Environmental Consulting Logo" 
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="text-lg font-bold">Raven Environmental</div>
                <div className="text-sm text-gray-400">Consulting, LLC</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Expert environmental consulting services specializing in air quality permits and compliance for Alaska.
            </p>
            <div className="space-y-2">
              <a
                href="tel:9076878263"
                data-testid="footer-phone"
                className="flex items-center space-x-2 text-gray-400 hover:text-emerald-400 transition-colors"
              >
                <Phone size={16} />
                <span>(907) 687-8263</span>
              </a>
              <a
                href="mailto:info@raven-environmental.com"
                data-testid="footer-email"
                className="flex items-center space-x-2 text-gray-400 hover:text-emerald-400 transition-colors"
              >
                <Mail size={16} />
                <span>info@raven-environmental.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" data-testid="footer-link-services" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/industries" data-testid="footer-link-industries" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Industries
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/permit-feasibility" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Environmental Permits
                </Link>
              </li>
              <li>
                <Link to="/services/compliance-support" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Air Quality Compliance
                </Link>
              </li>
              <li>
                <Link to="/services/regulatory-guidance" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Regulatory Support
                </Link>
              </li>
              <li>
                <Link to="/services/permit-applications" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Permit Applications
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left mb-4 md:mb-0">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Raven Environmental Consulting, LLC. All rights reserved.
              </p>
              <p className="text-gray-500 text-[10px] mt-2">
                Raven Environmental Consulting, LLC is an independently owned and operated company registered in Alaska.
              </p>
            </div>
            <div className="flex space-x-6">
              <Link 
                to="/privacy-policy" 
                className="text-gray-400 hover:text-emerald-400 transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-of-service" 
                className="text-gray-400 hover:text-emerald-400 transition-colors text-sm"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;